import { createFileRoute } from '@tanstack/react-router'
import TicketSubmitPage from '@/spa/pages/TicketSubmitPage'
import { routeErrorComponent } from '../../_shared/RouteError'

export const Route = createFileRoute('/ticket-submit/$id/')({
  component: TicketSubmitPage,
  errorComponent: routeErrorComponent,
})
